// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navigation {
  position: relative;
  padding: 1vw 3vw;
  overflow-y: scroll;
  overflow-x: hidden;
  flex: 1;
}
.Navigation::-webkit-scrollbar {
  width: 12px;
}
.Navigation .backdrop {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.4);
  height: 100%;
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 3;
}
.Navigation .popup-config-center {
  position: absolute;
  left: 50% !important;
  max-height: 75vh !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
  width: 75%;
}
.Navigation .popup-config-center .k-popup {
  max-height: 75vh;
}
.Navigation .popup-config-right {
  position: fixed !important;
  width: 40% !important;
  height: 100vh !important;
  right: 0% !important;
  top: 0% !important;
  left: unset !important;
}
.Navigation .popup-config-right .k-child-animation-container, .Navigation .popup-config-right .k-popup {
  height: 100%;
}
.Navigation .popup-config-container .popup-form-cancel-btn {
  cursor: pointer;
  display: flex !important;
  justify-content: right;
  margin: 10px;
}
.Navigation .popup-config-container .popup-form-cancel-btn i {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  justify-content: center;
  display: flex;
  align-items: center;
}
.Navigation .popup-config-container .popup-form-cancel-btn i:hover {
  background-color: #f0f0f0;
}
.Navigation .popup-config-container .k-popup {
  padding: 5px;
  overflow: auto;
}
.Navigation .popup-config-container .k-button {
  width: 15%;
  background-color: rgb(48, 133, 214);
  border-radius: 0.25em;
  color: #fff;
  font-size: 1.1em;
  border: 0;
  padding: 7px;
  margin-left: auto;
  font-weight: 500;
}
.Navigation .AppBuilderPage {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.Navigation .customActions {
  margin: 5px 0px 2px 0px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}
.Navigation .dash-manager-buttons {
  right: 0px;
  width: auto;
  float: left;
  position: relative;
}
.Navigation .dash-manager-buttons .btn-primary {
  color: #345561;
  background-color: #c5d2d6;
  border-radius: 42px;
  font-size: 13px;
  box-shadow: 0px 0px 5px 0px grey;
  height: auto;
  padding: 5px 10px;
  border-radius: 100%;
}
.Navigation .dash-manager-buttons .btn {
  margin: 4px;
  border-color: #eaeaea;
}
.Navigation .dashboard .btn-primary {
  color: #fff;
  background-color: #265160;
  border-color: #265160;
}
.Navigation .display-flex {
  display: flex;
}
.Navigation .flex-col {
  flex-direction: column;
}
.Navigation .gap-5 {
  gap: 5px;
}
.Navigation .gap-10 {
  gap: 10px;
}
.Navigation .task-header-pos-abs {
  position: absolute;
  top: 0;
  right: 0;
}
.Navigation .width-100 {
  width: 100%;
}
.Navigation .breadcrumbs {
  padding-top: 5px;
  padding-bottom: 0.8rem;
  display: contents;
  flex-direction: row;
  flex-wrap: wrap;
  line-height: 30px;
  border-radius: 1rem;
}
.Navigation .breadcrumbs-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 10px;
  color: #275362;
}
.Navigation .breadcrumbs-item a {
  color: #275362;
  padding-left: 5px;
  font-size: 24px;
}
.Navigation .breadcrumbs-item a:focus,
.Navigation .breadcrumbs-item a:hover {
  text-decoration: none;
}
.Navigation .breadcrumbs-item .seperator {
  margin-right: 0.5rem;
  color: #bababb;
  font-size: 24px;
}
.Navigation .searchInput {
  border: 0;
  background: transparent;
  letter-spacing: 1px;
  font-weight: 600;
  color: #1a1a1a;
  height: 30px;
  padding: 0px 0px 5px 10px;
  font-size: 1.75rem;
  font-weight: 300;
  width: 100%;
}
.Navigation abbr {
  text-decoration: none;
}
.Navigation .contentDiv {
  position: relative;
}
.Navigation .page-active,
.Navigation .contentDiv {
  height: 100%;
}
.Navigation .activeBreadcrumb a {
  color: #5cd4e3 !important;
}
.Navigation .activeBreadcrumb a:hover {
  color: #30c2d2 !important;
  text-decoration: underline !important;
}
.Navigation .tab-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  padding: 0.5rem 2rem;
  cursor: pointer;
  margin-right: 0;
  background-color: transparent;
  border: none;
  color: #444;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  padding-bottom: 1.125rem;
  width: 25%;
}
.Navigation .Navigation .tab-link:focus {
  outline: transparent;
}
.Navigation .tab-link:hover,
.Navigation .tab-link:focus {
  border-color: #e9ecef #e9ecef #dee2e6;
  outline: 0;
}
.Navigation .tab-link-active {
  border: none;
  -webkit-box-shadow: inset 0 -2px 0 #30c2d2;
  box-shadow: inset 0 -2px 0 #0a6ed1;
  color: #0a6ed1;
}
.Navigation .tab-content .contentDiv {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0.2rem 0.2rem 0.2rem 0.2rem;
}
.Navigation .searchBar {
  display: flex;
}
.Navigation .appButtons {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 10px;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.Navigation .appButtons .moduleBtn {
  align-items: center;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.Navigation .appButtons .moduleBtn .block {
  background-color: #275362;
  border-radius: 10px;
  color: white;
  font-size: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 125px;
  width: 125px;
}
.Navigation .appButtons .moduleBtn .titles {
  font-size: 26px;
  color: #275362;
  padding: 25px;
}

.show-more-action .show-more-actions {
  background: none !important;
  color: #212529 !important;
  transform: rotate(90deg) !important;
  font-size: 30px !important;
  border: none !important;
}
.show-more-action .show-more-actions::after {
  display: none;
}
.show-more-action .dropdown-menu {
  border-color: #dde2e7 !important;
  color: #212529 !important;
  background-color: #f8f9fa !important;
  font-size: 12px !important;
}

.gridActions-grid {
  display: grid;
  gap: 8px;
  align-items: center;
  grid-template-columns: repeat(auto-fill, minmax(30px, 1fr));
}
.gridActions-grid abbr {
  text-decoration: unset !important;
  display: flex;
  align-items: center;
  text-align: center;
}
.gridActions-grid abbr .render-operation-btn {
  display: flex !important;
  border: unset !important;
  box-shadow: grey 0px 0px 4px 0px;
  background-color: rgb(228, 231, 235) !important;
  border-radius: 50% !important;
  font-size: 14px !important;
  height: 30px !important;
  padding: 16px !important;
  width: auto;
  color: white;
  font-weight: 600;
}
.gridActions-grid abbr .render-operation-btn i {
  color: rgb(52, 85, 97) !important;
}

.searchInput {
  border: 0;
  background: transparent;
  letter-spacing: 1px;
  color: #1a1a1a;
  height: 30px;
  font-size: 1.75rem;
  font-weight: 300;
  display: inline-block;
  width: 100%;
}

.searchInput:focus {
  outline-color: transparent;
}

.k-popup {
  font-size: small;
  margin: unset;
  padding: unset;
}

.k-item:focus,
.k-list .k-item.k-state-focused {
  box-shadow: unset !important;
}

.k-list .k-item {
  background-color: #2a4f5d;
  color: white;
}

.breadcrumbParent {
  border-bottom: 1px solid #275362;
  margin-bottom: 0.8rem;
}

.breadcrumbHearder {
  margin-bottom: 0px;
}

.loaderAnimation {
  display: flex;
  height: 100%;
}

.loaderAnimation > div {
  margin: auto;
}

.searchPageDiv {
  width: 100%;
}

.searchPageDiv .seperator {
  border-bottom: 1px solid #275362;
  width: 80%;
  margin-top: 10px;
}

.searchText {
  padding: 1.5em;
}

.searchPageDiv .icon {
  box-sizing: border-box;
  color: #a5b4c4;
  display: block;
  fill: #a5b4c4;
  font-family: MaisonNeue, -apple-system, BlinkMacSystemFont, "Helvetica Neue", "Lucida Grande", sans-serif;
  font-size: 24px;
  height: 26px;
  position: relative;
  text-size-adjust: 100%;
}

.page-inactive {
  display: none;
}

.page-active {
  display: block;
}

.rygBadge {
  margin-left: auto;
  width: 80px;
  border: 3px solid lightgrey;
}

div#customActions > div[class="display-flex task-header-pos-abs"] {
  margin-top: 10px;
}

#customActions > button[title=View] {
  display: none;
}

.print-html-area-styles {
  border: 2px solid red;
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/App/Styles/PageComponentStyles.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;AADF;AAEE;EACE,WAAA;AAAJ;AAEE;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,UAAA;AAAF;AAGE;EACE,kBAAA;EACA,oBAAA;EACA,2BAAA;EACA,mBAAA;EACA,2CAAA;EACA,UAAA;AADJ;AAGI;EACE,gBAAA;AADN;AAKE;EACE,0BAAA;EACA,qBAAA;EACA,wBAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;AAHJ;AAKI;EACE,YAAA;AAHN;AAQI;EACI,eAAA;EACA,wBAAA;EACA,sBAAA;EACA,YAAA;AANR;AAQQ;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AANV;AAQU;EACE,yBAAA;AANZ;AAWI;EACE,YAAA;EACA,cAAA;AATN;AAYI;EACE,UAAA;EACA,mCAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAVN;AAcE;EACE,aAAA;EACA,sBAAA;EACA,OAAA;AAZJ;AAeE;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;AAbJ;AAgBE;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AAdJ;AAiBE;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAfJ;AAkBE;EACE,WAAA;EACA,qBAAA;AAhBJ;AAmBE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AAjBJ;AAoBE;EACE,aAAA;AAlBJ;AAqBE;EACE,sBAAA;AAnBJ;AAsBE;EACE,QAAA;AApBJ;AAuBE;EACE,SAAA;AArBJ;AAwBE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;AAtBJ;AAyBE;EACE,WAAA;AAvBJ;AA0BE;EACE,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAxBJ;AA2BE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAhLY;AAuJhB;AA2BI;EACE,cAnLU;EAoLV,iBAAA;EACA,eAAA;AAzBN;AA4BI;;EAEE,qBAAA;AA1BN;AA6BI;EACE,oBAAA;EACA,cAAA;EACA,eAAA;AA3BN;AA+BE;EACE,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AA7BJ;AAgCE;EACE,qBAAA;AA9BJ;AAiCE;EACE,kBAAA;AA/BJ;AAkCE;;EAEE,YAAA;AAhCJ;AAmCE;EACE,yBAAA;AAjCJ;AAoCE;EACE,yBAAA;EACA,qCAAA;AAlCJ;AAqCE;EACE,6BAAA;EACA,+BAAA;EACA,gCAAA;EACA,oBAAA;EACA,eAAA;EACA,eAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,4BAAA;EACA,oBAAA;EACA,wBAAA;EACA,UAAA;AAnCJ;AAsCE;EACE,oBAAA;AApCJ;AAuCE;;EAEE,qCAAA;EACA,UAAA;AArCJ;AAwCE;EACE,YAAA;EACA,0CAAA;EACA,kCAAA;EACA,cAAA;AAtCJ;AAyCE;EACE,cAAA;EACA,eAAA;EAEA,oCAAA;AAxCJ;AA2CE;EACE,aAAA;AAzCJ;AA4CE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;AA1CJ;AA4CI;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;AA1CN;AA4CM;EACE,yBApSQ;EAqSR,mBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;AA1CR;AA6CM;EACE,eAAA;EACA,cAjTQ;EAkTR,aAAA;AA3CR;;AAkDE;EAME,2BAAA;EACA,yBAAA;EACA,mCAAA;EACA,0BAAA;EACA,uBAAA;AApDJ;AAsDI;EACE,aAAA;AApDN;AAwDE;EACE,gCAAA;EACA,yBAAA;EACA,oCAAA;EACA,0BAAA;AAtDJ;;AA0DA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,2DAAA;AAvDF;AAyDE;EACE,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAvDJ;AAyDI;EACE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,+CAAA;EACA,6BAAA;EACA,0BAAA;EACA,uBAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAvDN;AAyDM;EACE,iCAAA;AAvDR;;AA6DA;EACE,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EAEA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;AA3DF;;AA8DA;EACE,0BAAA;AA3DF;;AA8DA;EACE,gBAAA;EACA,aAAA;EACA,cAAA;AA3DF;;AA8DA;;EAEE,4BAAA;AA3DF;;AA8DA;EACE,yBAAA;EACA,YAAA;AA3DF;;AA8DA;EACE,gCAAA;EACA,qBAAA;AA3DF;;AA8DA;EACE,kBAAA;AA3DF;;AA8DA;EACE,aAAA;EACA,YAAA;AA3DF;;AA8DA;EACE,YAAA;AA3DF;;AA8DA;EACE,WAAA;AA3DF;;AA8DA;EACE,gCAAA;EACA,UAAA;EACA,gBAAA;AA3DF;;AA8DA;EACE,cAAA;AA3DF;;AA8DA;EACE,sBAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;EACA,yGAAA;EAEA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AA5DF;;AA+DA;EACE,aAAA;AA5DF;;AA+DA;EACE,cAAA;AA5DF;;AA+DA;EACE,iBAAA;EACA,WAAA;EACA,2BAAA;AA5DF;;AAgEA;EACE,gBAAA;AA7DF;;AAgEA;EACE,aAAA;AA7DF;;AAgEA;EACE,qBAAA;AA7DF","sourcesContent":["$primary-color: #275362;\n\n.Navigation {\n  position: relative;\n  padding: 1vw 3vw;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  flex: 1;\n  &::-webkit-scrollbar {\n    width: 12px;\n  }\n  .backdrop{\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(0,0,0,.4);\n  height: 100%;\n  width: 100%;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  z-index: 3;\n  }\n\n  .popup-config-center {\n    position: absolute;\n    left: 50% !important;\n    max-height: 75vh !important;\n    top: 50% !important;\n    transform: translate(-50%, -50%) !important;\n    width: 75%;\n\n    .k-popup {\n      max-height: 75vh;\n    }\n  }\n\n  .popup-config-right {\n    position: fixed !important;\n    width: 40% !important;\n    height: 100vh !important;\n    right: 0% !important;\n    top: 0% !important;\n    left: unset !important;\n\n    .k-child-animation-container, .k-popup {\n      height: 100%;\n    }\n  }\n\n  .popup-config-container {\n    .popup-form-cancel-btn {\n        cursor: pointer;\n        display: flex !important;\n        justify-content: right;\n        margin: 10px;\n\n        i{\n          height: 20px;\n          width: 20px;\n          border-radius: 50%;\n          justify-content: center;\n          display: flex;\n          align-items: center;\n\n          &:hover{\n            background-color: #f0f0f0;\n          }\n        }\n      }\n\n    .k-popup {\n      padding: 5px;\n      overflow: auto;\n    }\n\n    .k-button {\n      width: 15%;\n      background-color: rgb(48, 133, 214);\n      border-radius: 0.25em;\n      color: #fff;\n      font-size: 1.1em;\n      border: 0;\n      padding: 7px;\n      margin-left: auto;\n      font-weight: 500;\n    }\n  }\n\n  .AppBuilderPage {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n  }\n\n  .customActions {\n    margin: 5px 0px 2px 0px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 12px;\n  }\n\n  .dash-manager-buttons {\n    right: 0px;\n    width: auto;\n    float: left; \n    position: relative;\n  }\n\n  .dash-manager-buttons .btn-primary {\n    color: #345561;\n    background-color: #c5d2d6;\n    border-radius: 42px;\n    font-size: 13px;\n    box-shadow: 0px 0px 5px 0px grey;\n    height: auto;\n    padding: 5px 10px;\n    border-radius: 100%;\n  }\n\n  .dash-manager-buttons .btn {\n    margin: 4px;\n    border-color: #eaeaea;\n  }\n\n  .dashboard .btn-primary {\n    color: #fff;\n    background-color: #265160;\n    border-color: #265160;\n  }\n\n  .display-flex {\n    display: flex;\n  }\n\n  .flex-col {\n    flex-direction: column;\n  }\n\n  .gap-5 {\n    gap: 5px;\n  }\n\n  .gap-10 {\n    gap: 10px;\n  }\n\n  .task-header-pos-abs {\n    position: absolute;\n    top: 0;\n    right: 0;\n  }\n\n  .width-100 {\n    width: 100%;\n  }\n\n  .breadcrumbs {\n    padding-top: 5px;\n    padding-bottom: 0.8rem;\n    display: contents;\n    flex-direction: row;\n    flex-wrap: wrap;\n    line-height: 30px;\n    border-radius: 1rem;\n  }\n\n  .breadcrumbs-item {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-right: 10px;\n    color: $primary-color;\n\n    a {\n      color: $primary-color;\n      padding-left: 5px;\n      font-size: 24px;\n    }\n\n    a:focus,\n    a:hover {\n      text-decoration: none;\n    }\n\n    .seperator {\n      margin-right: 0.5rem;\n      color: #bababb;\n      font-size: 24px;\n    }\n  }\n\n  .searchInput {\n    border: 0;\n    background: transparent;\n    letter-spacing: 1px;\n    font-weight: 600;\n    color: #1a1a1a;\n    height: 30px;\n    padding: 0px 0px 5px 10px;\n    font-size: 1.75rem;\n    font-weight: 300;\n    width: 100%;\n  }\n\n  abbr {\n    text-decoration: none;\n  }\n\n  .contentDiv {\n    position: relative;\n  }\n\n  .page-active,\n  .contentDiv {\n    height: 100%;\n  }\n\n  .activeBreadcrumb a {\n    color: #5cd4e3 !important;\n  }\n\n  .activeBreadcrumb a:hover {\n    color: #30c2d2 !important;\n    text-decoration: underline !important;\n  }\n\n  .tab-link {\n    border: 1px solid transparent;\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n    padding: 0.5rem 2rem;\n    cursor: pointer;\n    margin-right: 0;\n    background-color: transparent;\n    border: none;\n    color: #444;\n    -webkit-transition: all 0.2s;\n    transition: all 0.2s;\n    padding-bottom: 1.125rem;\n    width: 25%;\n  }\n\n  .Navigation .tab-link:focus {\n    outline: transparent;\n  }\n\n  .tab-link:hover,\n  .tab-link:focus {\n    border-color: #e9ecef #e9ecef #dee2e6;\n    outline: 0;\n  }\n\n  .tab-link-active {\n    border: none;\n    -webkit-box-shadow: inset 0 -2px 0 #30c2d2;\n    box-shadow: inset 0 -2px 0 #0a6ed1;\n    color: #0a6ed1;\n  }\n\n  .tab-content .contentDiv {\n    flex: 1 1 auto;\n    min-height: 1px;\n    // padding: 1.25rem;\n    padding: 0.2rem 0.2rem 0.2rem 0.2rem;\n  }\n\n  .searchBar {\n    display: flex;\n  }\n\n  .appButtons {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    padding: 10px;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n\n    .moduleBtn {\n      align-items: center;\n      display: flex;\n      flex-direction: column;\n      cursor: pointer;\n\n      .block {\n        background-color: $primary-color;\n        border-radius: 10px;\n        color: white;\n        font-size: 80px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 125px;\n        width: 125px;\n      }\n\n      .titles {\n        font-size: 26px;\n        color: $primary-color;\n        padding: 25px;\n      }\n    }\n  }\n}\n\n.show-more-action {\n  .show-more-actions {\n    // font-size: 10px !important;\n    // background: #e4e7eb !important;\n    // color: #345561 !important;\n    // border: none !important;\n    // box-shadow: grey 0px 0px 4px 0px !important;\n    background: none !important;\n    color: #212529 !important;\n    transform: rotate(90deg) !important;\n    font-size: 30px !important;\n    border: none !important;\n\n    &::after {\n      display: none;\n    }\n  }\n\n  .dropdown-menu {\n    border-color: #dde2e7 !important;\n    color: #212529 !important;\n    background-color: #f8f9fa !important;\n    font-size: 12px !important;\n  }\n}\n\n.gridActions-grid {\n  display: grid;\n  gap: 8px;\n  align-items: center;\n  grid-template-columns: repeat(auto-fill, minmax(30px, 1fr));\n\n  abbr {\n    text-decoration: unset !important;\n    display: flex;\n    align-items: center;\n    text-align: center;\n\n    .render-operation-btn {\n      display: flex !important;\n      border: unset !important;\n      box-shadow: grey 0px 0px 4px 0px;\n      background-color: rgb(228, 231, 235) !important;\n      border-radius: 50% !important;\n      font-size: 14px !important;\n      height: 30px !important;\n      padding: 16px !important;\n      width: auto;\n      color: white;\n      font-weight: 600;\n\n      i {\n        color: rgb(52, 85, 97) !important;\n      }\n    }\n  }\n}\n\n.searchInput {\n  border: 0;\n  background: transparent;\n  letter-spacing: 1px;\n  color: #1a1a1a;\n  height: 30px;\n  // padding: 0px 1rem 0 2.5rem;\n  font-size: 1.75rem;\n  font-weight: 300;\n  display: inline-block;\n  width: 100%;\n}\n\n.searchInput:focus {\n  outline-color: transparent;\n}\n\n.k-popup {\n  font-size: small;\n  margin: unset;\n  padding: unset;\n}\n\n.k-item:focus,\n.k-list .k-item.k-state-focused {\n  box-shadow: unset !important;\n}\n\n.k-list .k-item {\n  background-color: #2a4f5d;\n  color: white;\n}\n\n.breadcrumbParent {\n  border-bottom: 1px solid $primary-color;\n  margin-bottom: 0.8rem;\n}\n\n.breadcrumbHearder {\n  margin-bottom: 0px;\n}\n\n.loaderAnimation {\n  display: flex;\n  height: 100%;\n}\n\n.loaderAnimation>div {\n  margin: auto;\n}\n\n.searchPageDiv {\n  width: 100%;\n}\n\n.searchPageDiv .seperator {\n  border-bottom: 1px solid $primary-color;\n  width: 80%;\n  margin-top: 10px;\n}\n\n.searchText {\n  padding: 1.5em;\n}\n\n.searchPageDiv .icon {\n  box-sizing: border-box;\n  color: #a5b4c4;\n  display: block;\n  fill: #a5b4c4;\n  font-family: MaisonNeue, -apple-system, BlinkMacSystemFont, \"Helvetica Neue\",\n    \"Lucida Grande\", sans-serif;\n  font-size: 24px;\n  height: 26px;\n  position: relative;\n  text-size-adjust: 100%;\n}\n\n.page-inactive {\n  display: none;\n}\n\n.page-active {\n  display: block;\n}\n\n.rygBadge {\n  margin-left: auto;\n  width: 80px;\n  border: 3px solid lightgrey;\n}\n\n// Extra Space above the custombar\ndiv#customActions>div[class=\"display-flex task-header-pos-abs\"] {\n  margin-top: 10px;\n}\n\n#customActions>button[title=\"View\"] {\n  display: none;\n}\n\n.print-html-area-styles {\n  border: 2px solid red;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
